import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  Grid,
  Button,
  FormGroup,
  FormLabel,
} from '@mui/material';
import { selectAuthUser } from 'base/auth/selectors';
import { selectEnterprise } from 'base/core/selectors';
import { CreateFolderForm, ExpertUploadMediaParam } from 'pages/media-library/interface';
import { mediaLibraryAction } from 'pages/media-library/slice';
import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FileType } from 'utils/file-uploader';
import { ErrorMessage, PrimaryTextField } from '../../../../components';
import { createFolderValidationSchema } from '../upload-new-media/validation/add-media';

interface CreateFolderModalProps {
  path: string;
  onComplete: () => void;
}

const CreateMediaFolderForm = ({ path, onComplete }:CreateFolderModalProps) => {
  const { id: entId } = useSelector(selectEnterprise);
  const { id: expertId } = useSelector(selectAuthUser);
  const dispatch = useDispatch();

  const {
    register, handleSubmit, formState: { errors }, reset,
  } = useForm<CreateFolderForm>({
    resolver: yupResolver(createFolderValidationSchema),
    shouldFocusError: true,
  });
  const onSubmit: SubmitHandler<CreateFolderForm> = React.useCallback(async (data) => {
    const mediaData:ExpertUploadMediaParam = {
      path,
      expertId,
      entId,
      contentUrl: '',
      fileName: data.name,
      fileType: FileType.FOLDER,
      fileCategory: FileType.FOLDER,
      title: data.name,
      description: '',
      isExternalFile: false,
      thumbnailGenerated: '',
    };
    await new Promise((resolve, reject) => {
      dispatch(mediaLibraryAction.uploadMedia({
        ...mediaData,
        resolve,
        reject,
      }));
    });
    reset();
    onComplete();
  }, [dispatch, entId, expertId, onComplete, path, reset]);

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid container rowSpacing={6}>
        <Grid item xs={12}>
          <FormGroup>
            <FormLabel sx={{ mb: 2 }}>Folder name</FormLabel>
            <PrimaryTextField placeholder="Enter folder name" {...register('name')} />

            {errors.name && (<div className="mt-2"><ErrorMessage>{errors?.name?.message}</ErrorMessage></div>)}

          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" fullWidth>
            Create
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateMediaFolderForm;
